import { render, staticRenderFns } from "./SharedManuscriptListOnSlideMenu.vue?vue&type=template&id=40efe4ba&scoped=true&"
import script from "./SharedManuscriptListOnSlideMenu.vue?vue&type=script&lang=ts&"
export * from "./SharedManuscriptListOnSlideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SharedManuscriptListOnSlideMenu.vue?vue&type=style&index=0&id=40efe4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40efe4ba",
  null
  
)

export default component.exports